export const stylesContainer = {
    addCard: {
        wrapper: {},
        headerContainer: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            margin: "0px 0px 16px 0px"
        },
        headerMCLogo: {
            height: "28px",
            marginRight: "16px"
        },
        headerDivider: {
            height: "18px",
            border: "none",
            borderLeft: "1px solid #d0d0d0",
            marginRight: "16px"
        },
        headerVisaLogo: {
            height: "26px"
        },
        headerLogos: {
            height: "32px"
        },
        title: {
            fontSize: "18px",
            lineHeight: "26px",
            color: "#323232",
            marginBottom: "8px",
            textAlign: "center"
        },
        titleLight: {
            fontFamily: "AMX-Regular"
        },
        titleDark: {
            fontFamily: "AMX-Bold"
        },
        subtitle: {
            fontSize: "12px",
            lineHeight: "26px",
            color: "#222222",
            marginBottom: "32px",
            textAlign: "center"
        },
        subtitleLight: {
            fontFamily: "AMX-Regular"
        },
        subtitleDark: {
            fontFamily: "AMX-Bold"
        },
        inputLabel: {
            fontFamily: "AMX-Bold",
            fontSize: "12px",
            margin: "0px 0px 8px 0px",
            color: "#757575"
        },
        inputLabelFocused: {
            fontFamily: "AMX-Bold",
            fontSize: "12px",
            margin: "0px 0px 8px 0px",
            color: "#0071d1"
        },
        inputLabelError: {
            fontFamily: "AMX-Bold",
            fontSize: "12px",
            margin: "0px 0px 8px 0px",
            color: "#757575"
        },
        inputControl: {
            background: "transparent",
            paddingBottom: "5px",
            fontFamily: "AMX-Regular",
            fontSize: "15px",
            color: "#222222",
            width: "calc(100% - 5px)",
            border: "none",
            borderBottom: "1px solid #bac9d8",
            marginBottom: "32px"
        },
        inputControlFocused: {
            background: "transparent",
            paddingBottom: "5px",
            fontFamily: "AMX-Regular",
            fontSize: "15px",
            color: "#222222",
            width: "calc(100% - 5px)",
            border: "none",
            borderBottom: "1px solid #0071d1",
            marginBottom: "32px"
        },
        inputControlError: {
            background: "transparent",
            paddingBottom: "5px",
            fontFamily: "AMX-Regular",
            fontSize: "15px",
            color: "#222222",
            width: "calc(100% - 5px)",
            border: "none",
            borderBottom: "1px solid #d32222",
            marginBottom: "4px"
        },
        errorMessage: {
            fontFamily: "AMX-Bold",
            fontSize: "12px",
            margin: "0px 0px 32px 0px",
            color: "#d32222"
        },
        continueButtonInactive: {
            margin: "0px auto",
            display: "block",
            width: "100%",
            padding: "12px 0px 12px 0px",
            background: "#d0d0d0",
            fontFamily: "AMX-Bold",
            fontSize: "16px",
            lineHeight: "24px",
            color: "#595959",
            border: "none",
            borderRadius: "100px",
        },
        continueButtonActive: {
            margin: "0px auto",
            display: "block",
            width: "100%",
            padding: "12px 0px 12px 0px",
            background: "#7b1fa2",
            fontFamily: "AMX-Bold",
            fontSize: "16px",
            lineHeight: "24px",
            color: "#ffffff",
            border: "none",
            borderRadius: "100px",
        },
        continueButtonActiveLoading: {
            margin: "0px auto",
            display: "block",
            width: "100%",
            paddingTop: "11.5px",
            paddingBottom: "3.5px",
            background: "#7b1fa2",
            fontFamily: "AMX-Bold",
            fontSize: "16px",
            lineHeight: "24px",
            color: "#ffffff",
            border: "none",
            borderRadius: "100px",
        },
        errorWordingWrap: {
            padding: "0px",
            marginBottom: "32px",
            display: "grid",
            gridTemplateColumns: "4px auto",
            gap: "0px",
        },
        errorWordingLeft: {
            padding: "0px",
            border: "none",
            background: "#d32222",
            width: "4px"
        },
        errorWordingRight: {
            padding: "6px 16px 6px 12px",
            border: "1px solid #f7e6e6",
            borderLeft: "none",
            fontFamily: "AMX-Regular",
            fontSize: "14px",
            lineHeight: "18px",
            color: "#000000",
            background: "#fdf2f2",
        },
        infoMessage: {
            margin: "0px 0px 32px 0px",
            fontFamily: "AMX-Regular",
            fontSize: "12px",
            color: "#222222"
        }
    }
}